import React from "react"
import { Game } from "../../typings"

interface Props {
  games: Game[]
}

const RelevantGamesTable = ({ games }: Props) => (
  <div className="bg-white border rounded shadow">
    <div className="border-b p-3">
      <h5 className="font-bold uppercase text-gray-600">
        Existing games in or near this niche
      </h5>
    </div>
    <div className="p-5 overflow-x-scroll">
      {games.length > 0 && (
        <table className="w-full p-5 text-gray-700 whitespace-no-wrap">
          <thead>
            <tr>
              <th className="text-left text-blue-900 pr-4">Name</th>
              <th className="text-left text-blue-900 pr-4">Tag 1</th>
              <th className="text-left text-blue-900 pr-4">Tag 2</th>
              <th className="text-left text-blue-900 pr-4">Tag 3</th>
              <th className="text-left text-blue-900">Owners</th>
            </tr>
          </thead>

          <tbody>
            {games.map((game, i) => (
              <tr key={i}>
                <td>
                  <a
                    href={`https://store.steampowered.com/app/${game.id}`}
                    className="inline-block text-gray-600 underline hover:text-gray-900 hover:text-underline"
                  >
                    {game.name}
                  </a>
                </td>
                <td>{game.tags[0]}</td>
                <td>{game.tags[1]}</td>
                <td>{game.tags[2]}</td>
                <td>{game.owners}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {games.length == 0 && (
        <p>No games matching at least two of your tags found.</p>
      )}
    </div>
  </div>
)

export default RelevantGamesTable
